module.exports = __webpack_public_path__ + "img/gh-40370-1.prt.b0f72144.jpg";